import {FlexGridColumnGroup} from '@grapecity/wijmo.react.grid';
import Grid from '@mui/material/Grid';
// import {HttpStatusCode} from 'axios';
import PropTypes from 'prop-types';
import React from 'react';
import {connect} from 'react-redux';
// import {getComboName} from '../../../../../common/common.js';
// import {getSessionObject, setSessionObject} from '../../../../common/Session.js';
import {setSessionObject} from '../../../../common/Session.js';
// import {postRequest,
// putRequest
// } from '../../../../../common/backend.js';
// import {GMN, GMN_PATH} from '../../../../../common/commonConst.js';
import {GMN, GMN_PATH} from '../../../../common/commonConst.js';
import {createFieldItems, sysErr} from '../../../../common/commonGmn.js';
import {commonOperations} from '../../../../reducks/common/index.js';
import CustomFlexGrid from '../../../molecules/CustomFlexGrid.js';
import PaperPart from '../../../atoms/PaperPart.js';
// import PageTitle from '../../../../molecules/PageTitle.js';
// import FooterButton from '../../../../organisms/FooterButton.js';
import MainContainer from '../../../organisms/MainContainer.js';
import withRouter from '../../../organisms/withRouter.js';
// import WarningMessageArea from '../../../molecules/WarningMessageArea.js';
// import Approval from '../../../molecules/Approval.js';
import CustomBreadcrumbs from '../../../molecules/Breadcrumbs.js';
// import {AutoComplete} from '@grapecity/wijmo.input';
// import {DataMap} from '@grapecity/wijmo.grid';
import Typography from '@mui/material/Typography';
// import BackButton from '../../../atoms/Buttons/BackButton.js';
import {PositiveButton} from '../../../atoms/Buttons/PositiveButton.js';
// import NegativeButton from '../../../../atoms/Buttons/NegativeButton.js';
// import DeleteIcon from '@mui/icons-material/Delete';
// import SaveIcon from '@mui/icons-material/Save';
// import BFY60101G from './Popu';
import {withStyles} from '@mui/styles';
import {Field, reduxForm, getFormValues, getFormSyncWarnings} from 'redux-form';
import {renderTextField} from '../../../atoms/CustomPart.js';
// import {CellMaker} from '@grapecity/wijmo.grid.cellmaker';

import {
  Box,
  Tab,
} from '@mui/material';
import {
  TabContext,
  TabList,
  TabPanel,
} from '@mui/lab';

const styles = (theme) => ({
  button: {
    margin: '15px 10px 5px 10px',
  },
  wave: {
    fontSize: '1.2em',
    position: 'absolute',
    top: '50%',
    transform: 'translate(-50%,-50%)',
  },
  fields: {
    margin: '0px 10px 15px 10px',
  },
  textFieldDate: {
    margin: '0px 10px 15px 10px',
    width: '42%',
    minWidth: '100px',
  },
  tabPanel: {
    padding: '0px 5px 5px 5px',
    height: 'auto',
    overflowY: 'auto',
  },
  tabtitle: {
    backgroundColor: '#4d9bc1',
    padding: '0 0.1em',
  },
  accordionSummary: {
    color: '#fff',
    // backgroundColor: CommonTheme.palette.primary.main,
    backgroundColor: 'rgb(114, 160, 209)',
    borderTopLeftRadius: '4px',
    borderTopRightRadius: '4px',
  },
});

// お客さま情報Items
const gmnItemsSeikyu = {
  NWjigyosyo_code: {binding: 'NWjigyosyo_code', label: 'NW事業所', variant: 'outlined', required: false, type: 'text', sm: 6, readOnly: true, disabled: true},
  supplyPointNo: {binding: 'supplyPointNo', label: '供給地点特定番号', variant: 'outlined', required: false, type: 'text', sm: 6, readOnly: true, disabled: true},
  service_menu: {binding: 'service_menu', label: 'サービスメニュー', variant: 'outlined', required: false, type: 'text', sm: 6, readOnly: true, disabled: true},
  contractstatus_code: {binding: 'contractstatus_code', label: '契約状況コード', variant: 'outlined', required: false, type: 'text', sm: 6, readOnly: true, disabled: true},

  customerNo: {binding: 'customerNo', label: 'ご契約番号', variant: 'outlined', required: false, type: 'text', sm: 6, readOnly: true},
  customerName: {binding: 'customerName', label: 'お客さま名', variant: 'outlined', required: false, type: 'text', sm: 6, readOnly: true},
  customerName_kana: {binding: 'customerName_kana', label: 'お客さま名カナ', variant: 'outlined', required: false, type: 'text', sm: 6, readOnly: true},
  tell: {binding: 'tell', label: 'お客さま電話番号', variant: 'outlined', required: false, type: 'text', sm: 3, readOnly: true},
  address: {binding: 'address', label: '住所', variant: 'outlined', required: false, type: 'text', sm: 9, readOnly: true},
  address_supplement: {binding: 'address_supplement', label: '住所　補足', variant: 'outlined', required: false, type: 'text', sm: 6, readOnly: true},

  sectionNo: {binding: 'sectionNo', label: 'ブロック番号', variant: 'outlined', required: false, type: 'text', sm: 6, readOnly: true, disabled: true},
  contract_date: {binding: 'contract_date', label: '供給開始年月日', variant: 'outlined', required: false, type: 'text', sm: 6, readOnly: true},
  transfer_date: {binding: 'transfer_date', label: '異動年月日', variant: 'outlined', required: false, type: 'text', sm: 3, readOnly: true},
  power_factor: {binding: 'pole_number', label: '電柱番号', variant: 'outlined', required: false, type: 'text', sm: 3, readOnly: true},

  previous_surveyyear: {binding: 'previous_surveyyear', label: '前回調査年度', variant: 'outlined', required: false, type: 'text', sm: 3, readOnly: true},
  next_surveyyear: {binding: 'next_surveyyear', label: '次回個査年度', variant: 'outlined', required: false, type: 'text', sm: 3, readOnly: true},
  previous_inspectionyear: {binding: 'previous_inspectionyear', label: '前回調査年度', variant: 'outlined', required: false, type: 'text', sm: 3, readOnly: true},
  next_inspectionyear: {binding: 'next_inspectionyear', label: '次回個査年度', variant: 'outlined', required: false, type: 'text', sm: 3, readOnly: true},
  surveyyear: {binding: 'surveyyear', label: '個査年度', variant: 'outlined', required: false, type: 'text', sm: 3, readOnly: true},
  previous_individualyear: {binding: 'previous_individualyear', label: '前回調査年度', variant: 'outlined', required: false, type: 'text', sm: 3, readOnly: true},
  next_individualyear: {binding: 'next_individualyear', label: '次回個査年度', variant: 'outlined', required: false, type: 'text', sm: 3, readOnly: true},
  hijika_category: {binding: 'hijika_category', label: '調査管理区分', variant: 'outlined', required: false, type: 'text', sm: 3, readOnly: true},
  chousa_industry: {binding: 'chousa_industry', label: '調査業種', variant: 'outlined', required: false, type: 'text', sm: 3, readOnly: true},
  chousa_reason: {binding: 'chousa_reason', label: '調査理由', variant: 'outlined', required: false, type: 'text', sm: 3, readOnly: true},
  keiryou_kva: {binding: 'keiryou_kva', label: '計器有無', variant: 'standard', required: false, type: 'text', sm: 3, readOnly: true},

  previous_surveycode: {binding: 'previous_surveycode', label: '前回委託エリア', variant: 'standard', required: false, type: 'text', sm: 3, readOnly: true},
  next_surveycode: {binding: 'next_surveycode', label: '次回委託エリア', variant: 'standard', required: false, type: 'text', sm: 3, readOnly: true},
  previous_surveyarea: {binding: 'previous_surveyarea', label: '前回調査・点検委託エリア', variant: 'standard', required: false, type: 'text', sm: 3, readOnly: true},
  // next_surveyarea: {binding: 'next_surveyarea', label: '次回調査・点検委託エリア', variant: 'standard', required: false, type: 'text', sm: 3, readOnly: true},
  surveycode: {binding: 'surveycode', label: '委託エリア', variant: 'standard', required: false, type: 'text', sm: 3, readOnly: true},
  previous_researchcompany: {binding: 'previous_researchcompany', label: '前回調査会社', variant: 'standard', required: false, type: 'text', sm: 3, readOnly: true},
  next_researchcompany: {binding: 'next_researchcompany', label: '次回調査会社', variant: 'standard', required: false, type: 'text', sm: 3, readOnly: true},
  fix_researchcompany: {binding: 'fix_researchcompany', label: '調査会社固定', variant: 'standard', required: false, type: 'text', sm: 3, readOnly: true},
  datacategory: {binding: 'datacategory', label: '調査・点検データ区分', variant: 'standard', required: false, type: 'text', sm: 3, readOnly: true},
  haishiflag: {binding: 'haishiflag', label: '廃止フラグ', variant: 'standard', required: false, type: 'text', sm: 3, readOnly: true},
};

// 計器情報Items
const keikiItems = [
  {binding: 'keiki_Idx', header: 'No', dataType: 'String', width: 80, readOnly: true},
  {binding: 'keiki_ID', header: '計器ID', dataType: 'String', width: 150, readOnly: true},
  {binding: 'keiki_no', header: '計器番号', dataType: 'String', width: 150, readOnly: true},
  {binding: 'keiki_shitei', header: '計器指定番号', dataType: 'String', width: 150, readOnly: true},
  {binding: 'keiki_code', header: '計器管理コード', dataType: 'String', width: 500, readOnly: true},
];

// 計器情報（確定）Items
const keikiConItems = [
  {binding: 'keiki_Idx', header: 'No', dataType: 'String', width: 80, readOnly: true},
  {binding: 'keiki_ID', header: '計器ID', dataType: 'String', width: 150, readOnly: true},
  {binding: 'keiki_no', header: '計器番号', dataType: 'String', width: 150, readOnly: true},
];


const keikiList = [
  {keiki_Idx: '計器1', keiki_ID: '1000000001', keiki_shitei: '1', keiki_no: '001', keiki_code: '計器残置・屋内スイッチオフ'},
  {keiki_Idx: '計器2', keiki_ID: '1000000002', keiki_shitei: '2', keiki_no: '002', keiki_code: '計器残置・屋外スイッチオフ'},
  {keiki_Idx: '計器3', keiki_ID: '0000000000', keiki_shitei: '3', keiki_no: '003', keiki_code: '計器切断・確認カード要'},
  // {keiki_Idx: '計器4', keiki_ID: '0000000000', keiki_shitei: '4', keiki_no: '004', keiki_code: '計器切断・確認カード不要'},
  {keiki_Idx: '計器4', keiki_ID: '1100000010', keiki_shitei: '5', keiki_no: '005', keiki_code: '計器計器残置・ケッチヒューズ切断残置・屋内スイッチオフ'},
];

const keikiConList = [
  {keiki_Idx: '計器1', keiki_ID: '1000000001', keiki_no: '001'},
  {keiki_Idx: '計器2', keiki_ID: '1000000002', keiki_no: '002'},
  {keiki_Idx: '計器3', keiki_ID: '0000000000', keiki_no: '003'},
  {keiki_Idx: '計器4', keiki_ID: '1100000010', keiki_no: '005'},
];

// // 引込柱Items
// const dntItems = [
//   // {binding: 'dnt_ID', header: '支持物位置ID', dataType: 'String', width: 150, readOnly: true},
//   // {binding: 'senro_code', header: '線路コード', dataType: 'String', width: 150, readOnly: true},
//   {binding: 'senro_name', header: '線路名', dataType: 'String', width: 500, readOnly: true},
//   {binding: 'dnt_no', header: '電柱番号', dataType: 'String', width: 500, readOnly: true},
//   // {binding: 'kansen_no', header: '幹線No', dataType: 'String', width: 100, readOnly: true},
//   // {binding: 'bunki1', header: '第１分岐', dataType: 'String', width: 150, readOnly: true},
//   // {binding: 'bunki2', header: '第２分岐', dataType: 'String', width: 150, readOnly: true},
//   // {binding: 'bunki3', header: '第３分岐', dataType: 'String', width: 150, readOnly: true},
// ];

// const customerConList = [
//   {fuka_No: '1234567890123456789012', fuka_model: 'ABCD○×△□', fuka_capa: '100', fuka_num: '2'},
//   {fuka_No: '1234567890123456789012', fuka_model: 'ABCD○×△□', fuka_capa: '100', fuka_num: '2'},
//   {fuka_No: '1234567890123456789012', fuka_model: 'ABCD○×△□', fuka_capa: '100', fuka_num: '2'},
//   {fuka_No: '1234567890123456789012', fuka_model: 'ABCD○×△□', fuka_capa: '100', fuka_num: '2'},
// ];

/**
 * お客さま情報詳細
 * 画面ID:SCZ1009
 */
class Container extends React.Component {
  constructor(props) {
    super(props);
    // パラメータ取得
    // const storage = getSessionObject(GMN.CUSTOMER_INFO_INFO.id);
    const _list = [
      {gmnName: GMN.MENU.name, href: GMN_PATH.MENU},
      {gmnName: GMN.CUSTOMER_INFO_LIST.name, href: GMN_PATH.CUSTOMER_INFO_LIST},
      {gmnName: GMN.CUSTOMER_INFO_INFO.name, href: ''},
    ];
    let mode = 0;
    this.state = {
      buttonDisabled: true,
      alwaysClassBInputDisabled: false,
      spareClassBInputDisabled: false,
      tabIndex: 1,
      showDialog: false,
      transitionList: _list,
      mode: mode,
      listZigyojoMst: [],
      keikiList: [],
      dntList: [],
      customerConList: [],
    };
    // 一覧Ref作成
    this.gridRef = React.createRef();
    this.gridRef2 = React.createRef();
  }

  /** タブ情報 */
  tabItems = [
    {name: 'customerInfo', label: '最新', tabValue: 1},
    // {name: 'keikiInfo', label: '計器情報', tabValue: 2},
    {name: 'customerConInfo', label: '交付時', tabValue: 2},
  ];

  /**
   * 初期処理
   */
  async componentDidMount() {
    try {
      this.getInitializeData();
      this.props.doSetReferenceMode(false);
      return;
    } catch (error) {
      sysErr(this.props);
    }
  }

  /**
   * 初期データ検索
   */
  getInitializeData = async () => {
    // お客さま情報タブ
    let initItems = {};
    this.initializeItems(initItems);
    let data = {};
    let keikiList = {};
    let keikiConList = {};

    if (this.state.mode === 0) {
      data = {NWjigyosyo_code: '広島北', supplyPointNo: '1234567890123456789012', service_menu: '電灯定額接続送電サービス', contractstatus_code: '契約中', industry_code: '電灯', sectionNo: '00001', customerName: 'ＭＤＫＳテスト１３　４５６７９００２３４', customerName_kana: '△△△△△', customerNo: '190000012', tell: '082xxxxxxx', address: '731-0000　広島県安芸郡府中町瀬戸ハイム１丁目', contract_type: '05', contract_date: '2023/01/01', transfer_date: '2023/10/01', power_factor: '80', contract_capacity: '100', previous_surveyyear: '2022', next_surveyyear: '2026', previous_inspectionyear: '2023', next_inspectionyear: '2024', surveyyear: '2024', hijika_category: '非自家用', chousa_industry: 'プール', chousa_reason: '漏えい電流の測定不能', keiryou_kva: '10', haishiflag: '廃止なし', previous_surveycode: '中電NW', next_surveycode: '委託1', surveycode: '委託1', previous_surveyarea: '中電NW', next_surveyarea: '委託1', previous_researchcompany: '中電ＮＷ', next_researchcompany: '保安協会', fix_researchcompany: '保安協会', datacategory: '点検対象', pole_number: '1234567890123456789'};

      // 計器情報一覧
      keikiList = [
        {keiki_ID: '1000000001', keiki_shitei: '1', keiki_no: '001', keiki_code: '計器残置・屋内スイッチオフ'},
        {keiki_ID: '1000000002', keiki_shitei: '2', keiki_no: '002', keiki_code: '計器残置・屋外スイッチオフ'},
        {keiki_ID: '0000000000', keiki_shitei: '3', keiki_no: '003', keiki_code: '計器切断・確認カード要'},
        {keiki_ID: '0000000000', keiki_shitei: '4', keiki_no: '004', keiki_code: '計器切断・確認カード不要'},
        {keiki_ID: '1100000010', keiki_shitei: '5', keiki_no: '005', keiki_code: '計器計器残置・ケッチヒューズ切断残置・屋内スイッチオフ'},
      ];
      // // 引込柱一覧
      // dntList = [
      //   {dnt_no: '010 T 1 H03 S01', senro_name: '宇品幹(L041000)'},
      //   {dnt_no: '010 T 1 H03 S02', senro_name: '宇品幹(L042000)'},
      //   {dnt_no: '010 T 1 H03 S03', senro_name: '宇品幹(L043000)'},
      // ];
      // 計器情報（確定）一覧
      keikiConList = [
        {keiki_ID: '1000000001', keiki_no: '001'},
        {keiki_ID: '1000000002', keiki_no: '002'},
        {keiki_ID: '0000000000', keiki_no: '003'},
        {keiki_ID: '0000000000', keiki_no: '004'},
        {keiki_ID: '1100000010', keiki_no: '005'},
      ];
    }
    // お客さま情報データ設定
    for (const key of Object.keys(initItems)) {
      if (Object.hasOwn(data, key)) {
        initItems[key] = data[key];
      }
    }
    this.props.doSetInitValues(initItems);

    // 計器情報データを画面に設定
    if (this.gridRef.current) {
      this.gridRef.current.setItemsSource(keikiList);
    }
    // // 引込柱データを画面に設定
    // if (this.gridRef2.current) {
    //   this.gridRef2.current.setItemsSource(dntList);
    // }
    // 計器情報（確定）データを画面に設定
    if (this.gridRef2.current) {
      this.gridRef2.current.setItemsSource(keikiConList);
    }

    this.setState({
    });
  };

  /**
   * 画面項目初期化
   * @param {object} initItems
   */
  initializeItems = (initItems) => {
    const gmnItems = Object.assign(
        gmnItemsSeikyu,
    );
    for (const key of Object.keys(gmnItems)) {
      const item = gmnItems[key];
      if (Object.hasOwn(item, 'binding')) {
        initItems[item.binding] = null;
      }
    }
  };

  /**
   * コンボリスト作成
   * @param {array} itemsList
   * @param {string} label
   * @param {array} comboList
   */
  setComboList = (itemsList, label, comboList) => {
    const index = this.findIndex(itemsList, label);
    if (index !== -1) {
      itemsList[index].selections = comboList;
    }
  };

  /**
   * 配列検索
   * @param {array} list
   * @param {string} label
   * @return {number} インデックス
   */
  findIndex = (list, label) => {
    return list.findIndex((element) => {
      return element.label === label;
    });
  };

  /**
   * 登録
   */
  doCreate = async () => {
  };

  /**
   * 取下げ
   */
  doWithdraw = async () => {
  };

  /**
   * 一覧パーツ取得
   * @param {*} view 設定
   * @return {*} 一覧パーツ
   */
  getViewElem = (view) => {
    return <FlexGridColumnGroup
      binding={view.binding}
      header={view.header}
      dataType={view.dataType}
      format={view.format}
      width={view.width}
      isReadOnly={view.readOnly}/>;
  };

  /**
   * リンクの別タブで画面遷移
   * @param  {*} e
   */
  handleLinkClick = (e) => {
    e.preventDefault();
    const _data = this.state.seikyuInfo;
    // BFE10101G_請求一覧に遷移
    setSessionObject(
        GMN.BFE10101G.id,
        this.setParam('', _data),
    );
    window.open('/BFE10101G', '_blank');
  };

  /**
   * パラメータ設定
   * @param {*} list パラメータリスト
   * @param {*} data データ
   * @return {*} パラメータ
   */
  setParam = (list, data) =>{
    let _param = {};
    list.forEach((key) => {
      if (Object.hasOwn(data, key)) {
        _param[key] = data[key];
      }
    });
    return _param;
  };

  /**
   * 終了処理
   */
  async componentWillUnmount() {
    this.props.doSetInitValues(null);
  }

  async componentDidUpdate() {
    // 計器データを画面に設定
    if (this.gridRef.current) {
      this.gridRef.current.setItemsSource(keikiList);
    }
    // 計器（確定）データを画面に設定
    if (this.gridRef2.current) {
      this.gridRef2.current.setItemsSource(keikiConList);
    }
  }

  doClose = () => {
    let data = this.state.gamenData;
    this.props.doSetInitValues(data);
  };

  /**
   * タブ要素の生成。
   *
   * @return {{tabs: React.JSX.Element[], tabPanels: React.JSX.Element[]}} タブ要素
   */
  _createTabElements() {
    const tabs = [];
    const tabPanels = [];

    for (const tabItem of this.tabItems) {
      const tabName = tabItem.name;
      const tabValue = tabItem.tabValue;

      // タブを生成
      tabs.push(<Tab label={tabItem.label} value={tabValue} />);

      // タブパネルとその中の要素を生成
      tabPanels.push(this._createTabPanel(tabName, tabValue));
    }

    return {tabs, tabPanels};
  }

  /**
   * タブパネルとその中の要素生成。
   *
   * @param {string} name タブ名
   * @param {string} value タブ値(タブのvalueと一致させる)
   * @return {React.JSX.Element|null} タブパネルのJSX要素
   */
  _createTabPanel(name, value) {
    const {classes} = this.props;
    let conditionPaper = null;
    let conditionPaper1 = null;
    let conditionPaper2 = null;
    let conditionPaper3 = null;

    switch (name) {
      // お客さま情報
      case 'customerInfo':
        conditionPaper = this._getcustomerInfo(name);
        conditionPaper1 = this._getUnitMesh();
        conditionPaper2 = this._getinvestigation();
        conditionPaper3 = this._getkeikiInfo(this.gridRef);
        break;
      // // 計器情報
      // case 'keikiInfo':
      //   conditionPaper = this._getkeikiInfo(this.gridRef);
      //   break;
      // お客さま情報（確定）
      case 'customerConInfo':
        conditionPaper = this._getcustomerInfo(name);
        conditionPaper2 = this._getinvestigationCon();
        conditionPaper3 = this._getkeikiConInfo(this.gridRef2);
        break;
      default:
        break;
    }
    return (
      <TabPanel value={value} className={classes.tabPanel}
        // sx={{height: '500px', overflowY: 'auto'}}
      >
        {/* 検索条件 */}
        {conditionPaper}
        {conditionPaper1}
        {conditionPaper2}
        {conditionPaper3}
      </TabPanel>
    );
  }

  /**
   * タブクリック項目変更時の処理
   * @param {object} event
   * @param {string} newValue クリックしたタブのvalue
   */
  handleTabChange = (event, newValue) => {
    this.setState({tabIndex: newValue});
  };

  /**
   * 共通表示内容の取得
   * @param {*} items
   */
  getSelectItems = (items) => {
    let selectItems = items;
    console.log(selectItems);
    let data = this.state.gamenData;
    this.props.doSetInitValues(data);
    this.setState({modalOpen: false});
  };

  /**
   * お客さま情報タブ（契約情報）の要素生成
   * @param {string} name タブ
   * @return {*}
   */
  _getcustomerInfo(name) {
    const {classes} = this.props;
    return (
      <PaperPart>
        <Typography variant='h6' sx={{fontWeight: 'bold'}}>契約情報</Typography>
        <Grid
          container
          justifyContent="flex-start"
          alignItems="flex-start"
          spacing={1}
        >
          <Grid key="NWjigyosyo_code" item xs={12} sm={3}>
            <Field
              id="NWjigyosyo_code"
              name="NWjigyosyo_code"
              component={renderTextField}
              className={classes.fields}
              fullWidth
              label="NW事業所"
              type="text"
              InputProps={{
                readOnly: true,
                // disabled: true,
              }}
            />
          </Grid>
          <Grid key="supplyPointNo" item xs={12} sm={3}>
            <Field
              id="supplyPointNo"
              name="supplyPointNo"
              component={renderTextField}
              className={classes.fields}
              fullWidth
              label="供給地点特定番号"
              type="text"
              InputProps={{
                readOnly: true,
                // disabled: true,
              }}
            />
          </Grid>
          <Grid key="customerNo" item xs={12} sm={3}>
            <Field
              id="customerNo"
              name="customerNo"
              component={renderTextField}
              className={classes.fields}
              fullWidth
              label="契約番号"
              type="text"
              InputProps={{
                readOnly: true,
                // disabled: true,
              }}
            />
          </Grid>
          <Grid key="sectionNo" item xs={12} sm={3}>
            <Field
              id="sectionNo"
              name="sectionNo"
              component={renderTextField}
              className={classes.fields}
              fullWidth
              label="ブロック番号"
              type="text"
              InputProps={{
                readOnly: true,
                // disabled: true,
              }}
            />
          </Grid>
        </Grid>

        <Grid
          container
          justifyContent="flex-start"
          alignItems="flex-start"
          spacing={1}
        >
          <Grid key="contractstatus_code" item xs={12} sm={3}>
            <Field
              id="contractstatus_code"
              name="contractstatus_code"
              component={renderTextField}
              className={classes.fields}
              fullWidth
              label="契約状況コード"
              type="text"
              InputProps={{
                readOnly: true,
                // disabled: true,
              }}
            />
          </Grid>
          <Grid key="customerName" item xs={12} sm={6}>
            <Field
              id="customerName"
              name="customerName"
              component={renderTextField}
              className={classes.fields}
              fullWidth
              label="お客さま名"
              type="text"
              InputProps={{
                readOnly: true,
                // disabled: true,
              }}
            />
          </Grid>
          <Grid key="customerName_kana" item xs={12} sm={3}>
            <Field
              id="customerName_kana"
              name="customerName_kana"
              component={renderTextField}
              className={classes.fields}
              fullWidth
              label="お客さま名カナ"
              type="text"
              InputProps={{
                readOnly: true,
                // disabled: true,
              }}
            />
          </Grid>
          <Grid key="tell" item xs={12} sm={3}>
            <Field
              id="tell"
              name="tell"
              component={renderTextField}
              className={classes.fields}
              fullWidth
              label="お客さま電話番号"
              type="text"
              InputProps={{
                readOnly: true,
                // disabled: true,
              }}
            />
          </Grid>
          <Grid key="address" item xs={12} sm={6}>
            <Field
              id="address"
              name="address"
              component={renderTextField}
              className={classes.fields}
              fullWidth
              label="住所"
              type="text"
              InputProps={{
                readOnly: true,
                // disabled: true,
              }}
            />
          </Grid>
          <Grid key="address_supplement" item xs={12} sm={3}>
            <Field
              id="address_supplement"
              name="address_supplement"
              component={renderTextField}
              className={classes.fields}
              fullWidth
              label="住所　補足"
              type="text"
              InputProps={{
                readOnly: true,
                // disabled: true,
              }}
            />
          </Grid>
        </Grid>

        <Grid
          container
          justifyContent="flex-start"
          alignItems="flex-start"
          spacing={1}
        >
          <Grid key="pole_number" item xs={12} sm={3}>
            <Field
              id="pole_number"
              name="pole_number"
              component={renderTextField}
              className={classes.fields}
              fullWidth
              label="電柱番号"
              type="text"
              InputProps={{
                readOnly: true,
                // disabled: true,
              }}
            />
          </Grid>
          <Grid key="keyscz1008contract_date" item xs={12} sm={3}>
            <Field
              id="contract_date"
              name="contract_date"
              component={renderTextField}
              className={classes.fields}
              fullWidth
              label="供給開始年月日"
              type="text"
              InputProps={{
                readOnly: true,
                // disabled: true,
              }}
            />
          </Grid>
          <Grid key="keyscz1008transfer_date" item xs={12} sm={3}>
            <Field
              id="transfer_date"
              name="transfer_date"
              component={renderTextField}
              className={classes.fields}
              fullWidth
              label="異動年月日"
              type="text"
              InputProps={{
                readOnly: true,
                // disabled: true,
              }}
            />
          </Grid>
          <Grid key="service_menu" item xs={12} sm={3}>
            <Field
              id="service_menu"
              name="service_menu"
              component={renderTextField}
              className={classes.fields}
              fullWidth
              label="サービスメニュー"
              type="text"
              InputProps={{
                readOnly: true,
                // disabled: true,
              }}
            />
          </Grid>
        </Grid>
        {(name == 'customerConInfo') ?
        <Grid
          container
          justifyContent="flex-start"
          alignItems="flex-start"
          spacing={1}
        >
          <Grid key="keiryou" item xs={12} sm={3}>
            <Field
              id="keiryou_kva"
              name="keiryou_kva"
              component={renderTextField}
              className={classes.fields}
              fullWidth
              label="契約容量電力"
              type="text"
              InputProps={{
                readOnly: true,
              // disabled: true,
              }}
            />
          </Grid>
        </Grid> :
        <Grid
          container
          justifyContent="flex-start"
          alignItems="flex-start"
          spacing={1}
        >
          <Grid key="keiryou_kva" item xs={12} sm={3}>
            <Field
              id="keiryou_kva"
              name="keiryou_kva"
              component={renderTextField}
              className={classes.fields}
              fullWidth
              label="契約容量（ＫＶＡ）"
              type="text"
              InputProps={{
                readOnly: true,
                // disabled: true,
              }}
            />
          </Grid>
          <Grid key="keiryou_kw" item xs={12} sm={3}>
            <Field
              id="keiryou_kw"
              name="keiryou_kw"
              component={renderTextField}
              className={classes.fields}
              fullWidth
              label="契約電力（ＫＷ）"
              type="text"
              InputProps={{
                readOnly: true,
                // disabled: true,
              }}
            />
          </Grid>
        </Grid>
        }
      </PaperPart>
    );
  };

  /**
   * お客さま情報タブ（単位メッシュ）の要素生成
   * @return {*}
   */
  _getUnitMesh() {
    const {classes} = this.props;
    return (
      <PaperPart>
        <Typography variant='h6' sx={{fontWeight: 'bold'}}>単位メッシュ</Typography>
        <Grid
          container
          justifyContent="flex-start"
          alignItems="flex-start"
          spacing={1}
        >
          <Grid key="previous_surveyyear" item xs={12} sm={3}>
            <Field
              id="previous_surveyyear"
              name="previous_surveyyear"
              component={renderTextField}
              className={classes.fields}
              fullWidth
              label="前回調査年度"
              type="text"
              InputProps={{
                readOnly: true,
                // disabled: true,
              }}
            />
          </Grid>
          <Grid key="next_surveyyear" item xs={12} sm={3}>
            <Field
              id="next_surveyyear"
              name="next_surveyyear"
              component={renderTextField}
              className={classes.fields}
              fullWidth
              label="次回調査年度"
              type="text"
              InputProps={{
                readOnly: true,
                // disabled: true,
              }}
            />
          </Grid>
          <Grid key="previous_surveycode" item xs={12} sm={3}>
            <Field
              id="previous_surveycode"
              name="previous_surveycode"
              component={renderTextField}
              className={classes.fields}
              fullWidth
              label="前回委託エリア"
              type="text"
              InputProps={{
                readOnly: true,
                // disabled: true,
              }}
            />
          </Grid>
          <Grid key="next_surveycode" item xs={12} sm={3}>
            <Field
              id="next_surveycode"
              name="next_surveycode"
              component={renderTextField}
              className={classes.fields}
              fullWidth
              label="次回委託エリア"
              type="text"
              InputProps={{
                readOnly: true,
                // disabled: true,
              }}
            />
          </Grid>
        </Grid>
      </PaperPart>
    );
  };
  /**
   * お客さま情報タブ（調査・点検）の要素生成
   * @return {*}
   */
  _getinvestigation() {
    const {classes} = this.props;
    return (
      <PaperPart>
        <Typography variant='h6' sx={{fontWeight: 'bold'}}>調査・点検</Typography>
        <Grid
          container
          justifyContent="flex-start"
          alignItems="flex-start"
          spacing={1}
        >
          <Grid key="previous_individualyear" item xs={12} sm={3}>
            <Field
              id="previous_surveyyear"
              name="previous_surveyyear"
              component={renderTextField}
              className={classes.fields}
              fullWidth
              label="前回調査年度"
              type="text"
              InputProps={{
                readOnly: true,
                // disabled: true,
              }}
            />
          </Grid>
          <Grid key="next_surveyyear" item xs={12} sm={3}>
            <Field
              id="next_surveyyear"
              name="next_surveyyear"
              component={renderTextField}
              className={classes.fields}
              fullWidth
              label="次回調査年度"
              type="text"
              InputProps={{
                readOnly: true,
                // disabled: true,
              }}
            />
          </Grid>
          <Grid key="previous_inspectionyear" item xs={12} sm={3}>
            <Field
              id="previous_inspectionyear"
              name="previous_inspectionyear"
              component={renderTextField}
              className={classes.fields}
              fullWidth
              label="前回点検年度"
              type="text"
              InputProps={{
                readOnly: true,
                // disabled: true,
              }}
            />
          </Grid>
          <Grid key="next_inspectionyear" item xs={12} sm={3}>
            <Field
              id="next_inspectionyear"
              name="next_inspectionyear"
              component={renderTextField}
              className={classes.fields}
              fullWidth
              label="次回点検年度"
              type="text"
              InputProps={{
                readOnly: true,
                // disabled: true,
              }}
            />
          </Grid>
        </Grid>

        <Grid
          container
          justifyContent="flex-start"
          alignItems="flex-start"
          spacing={1}
        >
          <Grid key="previous_surveyarea" item xs={12} sm={3}>
            <Field
              id="previous_surveyarea"
              name="previous_surveyarea"
              component={renderTextField}
              className={classes.fields}
              fullWidth
              label="前回調査・点検委託エリア"
              type="text"
              InputProps={{
                readOnly: true,
                // disabled: true,
              }}
            />
          </Grid>
          <Grid key="next_surveyarea" item xs={12} sm={3}>
            {/* <Field
              id="next_surveyarea"
              name="next_surveyarea"
              component={renderTextField}
              className={classes.fields}
              fullWidth
              label="次回調査・点検委託エリア"
              type="text"
              InputProps={{
                readOnly: true,
                // disabled: true,
              }}
            /> */}
          </Grid>
          <Grid key="previous_researchcompany" item xs={12} sm={3}>
            <Field
              id="previous_researchcompany"
              name="previous_researchcompany"
              component={renderTextField}
              className={classes.fields}
              fullWidth
              label="前回調査会社"
              type="text"
              InputProps={{
                readOnly: true,
                // disabled: true,
              }}
            />
          </Grid>
          <Grid key="next_researchcompany" item xs={12} sm={3}>
            {/* <Field
              id="next_researchcompany"
              name="next_researchcompany"
              component={renderTextField}
              className={classes.fields}
              fullWidth
              label="次回調査会社"
              type="text"
              InputProps={{
                readOnly: true,
                // disabled: true,
              }}
            /> */}
          </Grid>
        </Grid>

        <Grid
          container
          justifyContent="flex-start"
          alignItems="flex-start"
          spacing={1}
        >
          <Grid key="hijika_category" item xs={12} sm={3}>
            <Field
              id="hijika_category"
              name="hijika_category"
              component={renderTextField}
              className={classes.fields}
              fullWidth
              label="調査管理区分"
              type="text"
              InputProps={{
                readOnly: true,
                // disabled: true,
              }}
            />
          </Grid>
          <Grid key="chousa_industry" item xs={12} sm={3}>
            <Field
              id="chousa_industry"
              name="chousa_industry"
              component={renderTextField}
              className={classes.fields}
              fullWidth
              label="調査業種"
              type="text"
              InputProps={{
                readOnly: true,
                // disabled: true,
              }}
            />
          </Grid>
          <Grid key="chousa_reason" item xs={12} sm={3}>
            <Field
              id="chousa_reason"
              name="chousa_reason"
              component={renderTextField}
              className={classes.fields}
              fullWidth
              label="調査理由"
              type="text"
              InputProps={{
                readOnly: true,
                // disabled: true,
              }}
            />
          </Grid>
        </Grid>
      </PaperPart>
    );
  };

  /**
   * お客さま情報タブ（調査・点検）（確定）の要素生成
   * @return {*}
   */
  _getinvestigationCon() {
    const {classes} = this.props;
    return (
      <PaperPart>
        <Typography variant='h6' sx={{fontWeight: 'bold'}}>調査・点検</Typography>
        <Grid
          container
          justifyContent="flex-start"
          alignItems="flex-start"
          spacing={1}
        >
          <Grid key="surveyyear" item xs={12} sm={3}>
            <Field
              id="surveyyear"
              name="surveyyear"
              component={renderTextField}
              className={classes.fields}
              fullWidth
              label="年度"
              type="text"
              InputProps={{
                readOnly: true,
                // disabled: true,
              }}
            />
          </Grid>
          <Grid key="surveycode" item xs={12} sm={3}>
            <Field
              id="surveycode"
              name="surveycode"
              component={renderTextField}
              className={classes.fields}
              fullWidth
              label="委託エリア"
              type="text"
              InputProps={{
                readOnly: true,
                // disabled: true,
              }}
            />
          </Grid>
        </Grid>
        <Grid
          container
          justifyContent="flex-start"
          alignItems="flex-start"
          spacing={1}
        >
          <Grid key="datacategory" item xs={12} sm={3}>
            <Field
              id="datacategory"
              name="datacategory"
              component={renderTextField}
              className={classes.fields}
              fullWidth
              label="調査・点検データ区分"
              type="text"
              InputProps={{
                readOnly: true,
                // disabled: true,
              }}
            />
          </Grid>
          <Grid key="hijika_category" item xs={12} sm={3}>
            <Field
              id="hijika_category"
              name="hijika_category"
              component={renderTextField}
              className={classes.fields}
              fullWidth
              label="調査管理区分"
              type="text"
              InputProps={{
                readOnly: true,
                // disabled: true,
              }}
            />
          </Grid>
          <Grid key="chousa_industry" item xs={12} sm={3}>
            <Field
              id="chousa_industry"
              name="chousa_industry"
              component={renderTextField}
              className={classes.fields}
              fullWidth
              label="調査業種"
              type="text"
              InputProps={{
                readOnly: true,
                // disabled: true,
              }}
            />
          </Grid>
          <Grid key="chousa_reason" item xs={12} sm={3}>
            <Field
              id="chousa_reason"
              name="chousa_reason"
              component={renderTextField}
              className={classes.fields}
              fullWidth
              label="調査理由"
              type="text"
              InputProps={{
                readOnly: true,
                // disabled: true,
              }}
            />
          </Grid>
        </Grid>
      </PaperPart>
    );
  };

  /**
   * 計器情報の要素生成
   * @return {*}
   */
  _getkeikiInfo() {
    // const {classes} = this.props;
    return (
      <PaperPart>
        <Typography variant='h6' sx={{fontWeight: 'bold'}}>計器情報</Typography>
        {this.keikiTable()}
      </PaperPart>
    );
  };

  /**
   * 計器情報（確定）の要素生成
   * @return {*}
   */
  _getkeikiConInfo() {
    // const {classes} = this.props;
    return (
      <PaperPart>
        <Typography variant='h6' sx={{fontWeight: 'bold'}}>計器情報</Typography>
        {this.keikiConTable()}
      </PaperPart>
    );
  };

  // /**
  //  * 引込柱情報の要素生成
  //  * @return {*}
  //  */
  // _getdntInfo() {
  //   // const {classes} = this.props;
  //   return (
  //     <PaperPart>
  //       <Typography variant='h6' sx={{fontWeight: 'bold'}}>引込柱</Typography>
  //       {this.dntTable()}
  //     </PaperPart>
  //   );
  // };

  // /**
  //  * 計器情報タブの要素生成
  //  *
  //  * @param {object} ref 参照
  //  * @return {React.JSX.Element|null} タブのJSX要素
  //  */
  // _getkeikiInfo(ref) {
  //   const {classes,
  //   } = this.props;

  //   return (
  //     <form noValidate autoComplete="off" className={classes.root}>
  //       <PaperPart>
  //         {this.keikiTable(ref)}
  //       </PaperPart>
  //     </form>
  //   );
  // };

  /**
   * 計器情報一覧描画
   *
   * @return {*}
   */
  keikiTable() {
    const props = {
      rowHeaderType: 'None',
      filterOn: true,
      headersVisibility: 'Column',
      allowDragging: 'None',
      allowSorting: 'SingleColumn',
      AddDeleteOn: false,
      style: {maxWidth: '1450px', height: 'auto', width: 'auto', marginTop: '20px'},
      isReadOnly: true,
      required: false,
    };
    // 一覧定義取得
    let viewElems = [];
    if (keikiItems) {
      for (const view of keikiItems) {
        let viewElem;
        if (view.dataType === 'header') {
          let viewGroups = [];
          viewElem = <FlexGridColumnGroup header={view.header}>
            {viewGroups}
          </FlexGridColumnGroup>;
        } else {
          viewElem = this.getViewElem(view);
        }
        viewElems.push(viewElem);
      }
    }
    return (
      <CustomFlexGrid ref={this.gridRef} {...props}>
        {viewElems}
      </CustomFlexGrid>
    );
  }
  /**
   * 計器情報（確定）一覧描画
   *
   * @return {*}
   */
  keikiConTable() {
    const props = {
      rowHeaderType: 'None',
      filterOn: true,
      headersVisibility: 'Column',
      allowDragging: 'None',
      allowSorting: 'SingleColumn',
      AddDeleteOn: false,
      style: {maxWidth: '1450px', height: 'auto', width: 'auto', marginTop: '20px'},
      isReadOnly: true,
      required: false,
    };
    // 一覧定義取得
    let viewElems = [];
    if (keikiConItems) {
      for (const view of keikiConItems) {
        let viewElem;
        if (view.dataType === 'header') {
          let viewGroups = [];
          viewElem = <FlexGridColumnGroup header={view.header}>
            {viewGroups}
          </FlexGridColumnGroup>;
        } else {
          viewElem = this.getViewElem(view);
        }
        viewElems.push(viewElem);
      }
    }
    return (
      <CustomFlexGrid ref={this.gridRef2} {...props}>
        {viewElems}
      </CustomFlexGrid>
    );
  }

  // /**
  //  * 引込柱一覧描画
  //  *
  //  * @return {*}
  //  */
  // dntTable() {
  //   const props = {
  //     rowHeaderType: 'None',
  //     filterOn: true,
  //     headersVisibility: 'Column',
  //     allowDragging: 'None',
  //     allowSorting: 'SingleColumn',
  //     AddDeleteOn: false,
  //     style: {maxWidth: '1450px', height: 'auto', width: 'auto', marginTop: '20px'},
  //     isReadOnly: true,
  //     required: false,
  //   };
  //   // 一覧定義取得
  //   let viewElems = [];
  //   if (dntItems) {
  //     for (const view of dntItems) {
  //       let viewElem;
  //       if (view.dataType === 'header') {
  //         let viewGroups = [];
  //         viewElem = <FlexGridColumnGroup header={view.header}>
  //           {viewGroups}
  //         </FlexGridColumnGroup>;
  //       } else {
  //         viewElem = this.getViewElem(view);
  //       }
  //       viewElems.push(viewElem);
  //     }
  //   }
  //   return (
  //     <CustomFlexGrid ref={this.gridRef2} {...props}>
  //       {viewElems}
  //     </CustomFlexGrid>
  //   );
  // }

  /**
   * お客さま情報（確定）タブの要素生成
   *
   * @param {object} ref 参照
   * @return {React.JSX.Element|null} タブのJSX要素
   */
  _getcustomerConInfo(ref) {
    const {classes,
    } = this.props;

    return (
      <form noValidate autoComplete="off" className={classes.root}>
        <PaperPart>
          {this.customerConTable(ref)}
        </PaperPart>
      </form>
    );
  };

  /**
   * フッタボタン
   * @return {JSX.Element}
   */
  renderFooterBtn() {
    const {
      handleSubmit,
    } = this.props;

    return (
      <Grid
        container
        justifyContent="center"
        alignItems="flex-start"
        spacing={1}
      >
        <Grid key="SurveyIndustryInfo" item>
          <PositiveButton
            id="SurveyIndustryInfo"
            onClick={handleSubmit(this.SurveyIndustryInfoLink)}
            variant="contained"
          >
            <span>調査業種管理</span>
          </PositiveButton>
        </Grid>
        <Grid key="SurveyIndustryReasonInfo" item>
          <PositiveButton
            id="SurveyIndustryReasonInfo"
            onClick={handleSubmit(this.SurveyIndustryReasonInfoLink)}
            variant="contained"
          >
            <span>翌年度再調査管理</span>
          </PositiveButton>
        </Grid>
      </Grid>
    );
  };

  /**
   * 調査年度・委託エリア管理クリック時
   */
  SurveyYearCompanyInfoLink = async () => {
    try {
      let params = {
        mod: 'I',
      };
      setSessionObject(GMN.SURVEY_YEAR_COMPANY_INFO.id, params);
      this.props.navigate(GMN_PATH.SURVEY_YEAR_COMPANY_INFO);
    } catch (error) {
      this.props.doShowMessage({
        message: 'TKSCS00001S',
        action: () => {
          this.props.history.push('/login');
        },
      });
    }
  };

  /**
   * 調査業種管理クリック時
   */
  SurveyIndustryInfoLink = async () => {
    try {
      let params = {
        mod: 'I',
      };
      setSessionObject(GMN.SURVEY_INDUSTRY_INFO.id, params);
      this.props.navigate(GMN_PATH.SURVEY_INDUSTRY_INFO);
    } catch (error) {
      this.props.doShowMessage({
        message: 'TKSCS00001S',
        action: () => {
          this.props.history.push('/login');
        },
      });
    }
  };

  /**
   * 翌年度再調査管理クリック時
   */
  SurveyIndustryReasonInfoLink = async () => {
    try {
      let params = {
        mod: 'I',
      };
      setSessionObject(GMN.SURVEY_REASON_INFO.id, params);
      this.props.navigate(GMN_PATH.SURVEY_REASON_INFO);
    } catch (error) {
      this.props.doShowMessage({
        message: 'TKSCS00001S',
        action: () => {
          this.props.history.push('/login');
        },
      });
    }
  };

  /**
   * 画面描画
   * @return {*}
   */
  render() {
    const {userInfo} = this.props;
    let itemListSeikyu = createFieldItems(gmnItemsSeikyu);
    this.setComboList(itemListSeikyu, '事業場', this.state.listZigyojoMst);

    const {classes,
      // generalPurposeMap, reset,
      // handleSubmit,
      // userInfo
    } = this.props;

    // フッタボタンを生成
    const footerBtn = this.renderFooterBtn();

    // タブとタブパネルを生成
    const tabElements = this._createTabElements();

    return (
      <form noValidate autoComplete="off" className={classes.root}>
        <MainContainer
          props={this.props}
          ActorName={userInfo.ActorName}
          footerBtn={footerBtn}
        >
          <CustomBreadcrumbs key="keyBreadcrumbs" items={this.state.transitionList}/>
          <Grid key="keyBFE10112GOrderGrid" item xs={12}>
            <PaperPart>
              {/* <Typography variant='h6' sx={{fontWeight: 'bold'}}>お客さま情報</Typography> */}
              <TabContext value={this.state.tabIndex}>
                <Box sx={{borderBottom: 1, borderColor: 'divider'}}>
                  <TabList onChange={this.handleTabChange} textColor="primary" indicatorColor="primary">
                    {tabElements.tabs}
                  </TabList>
                </Box>
                {tabElements.tabPanels}
              </TabContext>
              {/* <Grid key="customerInfo" item xs={12}>
                {this._getcustomerInfo()}
              </Grid>
              <Grid key="investigation" item xs={12}>
                {this._getinvestigation()}
              </Grid>
              <Grid key="keikiInfoTable" item xs={12}>
                {this._getkeikiInfo()}
              </Grid> */}
            </PaperPart>
            {/* <PaperPart>
              <Grid key="customerConInfoTable" item xs={12}>
                {this._getcustomerConInfo()}
              </Grid>
            </PaperPart> */}
          </Grid>
        </MainContainer>
      </form>
    );
  }
}

const FORM_NAME = 'SCA1009FORM';
Container = reduxForm({
  form: FORM_NAME,
  destroyOnUnmount: false,
  enableReinitialize: true,
})(connect((state) => {
  return {
    values: getFormValues(FORM_NAME)(state),
    syncWarnings: getFormSyncWarnings(FORM_NAME)(state),
  };
})(Container));

Container.propTypes = {
  classes: PropTypes.object,
  userInfo: PropTypes.object,
  values: PropTypes.object,
  handleSubmit: PropTypes.func,
  doShowMessage: PropTypes.func,
  doSetInitValues: PropTypes.func,
  navigate: PropTypes.func,
  title: PropTypes.string,
  genericMap: PropTypes.object,
  doSetReferenceMode: PropTypes.func,
  history: PropTypes.object,
};

const mapStateToProps = (state) => {
  return {
    userInfo: state.auth.userInfo,
    initialValues: state.common.setInitValues,
    genericMap: state.common.generalPurposeMap,
  };
};

const mapDispatchToProps = {
  doShowMessage: commonOperations.doShowMessage,
  doSetInitValues: commonOperations.doSetInitValues,
  doSetReferenceMode: commonOperations.doSetReferenceMode,
};

// Container = reduxForm({
//   form: FORM_NAME,
//   destroyOnUnmount: false,
//   enableReinitialize: true,
// })(connect((state) => {
//   return {
//     values: getFormValues(FORM_NAME)(state),
//   };
// })(Container));

export default withStyles(styles)(
    connect(
        mapStateToProps,
        mapDispatchToProps,
    )(withRouter(Container)),
);
